<template>
  <div>
    <v-btn
      class="action-bar__btn"
      round
      depressed
      color="accent"
      @click="openDialog"
    >
      {{ $t(`${namespace}.newProject`) }}
    </v-btn>

    <NewProjectDialog
      :visible="newProjectDialog"
      @close="(reload) => {
        closeDialog()

        if (reload) {
          this.$emit('updateView')
          this.$emit('change')
        }
      }"
    />
  </div>
</template>

<script>
import NewProjectDialog from 'components/projects/NewProjectDialog'

export default {
  name: 'NewProjectAction',
  components: {
    NewProjectDialog
  },
  computed: {
    modalVisible () {
      return Boolean(this.$route.query && this.$route.query.modal)
    }
  },
  data () {
    return {
      namespace: 'Views.ProjectsPage',
      newProjectDialog: false
    }
  },
  methods: {
    openDialog () {
      this.newProjectDialog = true
    },
    closeDialog () {
      this.newProjectDialog = false
    },
    clearUrlQueryParam () {
      window.setTimeout(() => {
        this.$router.push(this.$route.path).catch(() => {})
      }, 100)
    }
  },
  mounted () {
    if (this.modalVisible) {
      setTimeout(() => {
        this.openDialog()
        this.clearUrlQueryParam()
      }, 1000)
    }
  }
}
</script>
